import {useState, useEffect, useRef} from 'react';
import {Top, Bottom, Button, Logo, Checkbox, CircularProgress, ChoiceList} from "parts";
import {useNavigate, useParams, useSearchParams} from "react-router-dom";
import {getUrl, upTimer} from "utils/lib";
import {useTranslation} from "react-i18next";
import {identify, setStep, setTrack, useSurvey} from "utils";
import {LandingEnum, SurveyEnum} from "_business";

export function Loading({step, toAdd, nextUrl, preload}) {
  const
    {t, i18n} = useTranslation('common', {keyPrefix: 'loading'}),
    {t: t0} = useTranslation(),
    {uid} = useParams(),
    [searchParams] = useSearchParams(),
    navigate = useNavigate()

  const
    headerRef = useRef(null),

    programList =
      t(
        'programList' + (uid ? '-' + window.landing : ''),
        {returnObjects: true}
      )

  // const A22 = i18n.resolvedLanguage === 'en' ? getExperiment('A22') : {value: 'A'}
  // const A25 = getExperiment('A25')

  for (const item of programList)
    item.value = 0

  const [state, setState] = useState({
    timer: null,
    intervals: [3000, 4000, 5000, 4000],
    programList,
    resultList: [],
    // summarize: [],
  })

  const pause = 49

  let
    isNext = true,
    header = i18n.exists('loading.name') ? t('name') : ''

  for (const item of state.programList) {
    if (item.value < 100) {
      if (item.loads)
        header = item.loads[item.value < 50 || item.loads.length <= 1 ? 0 : 1]

      isNext = false
      break
    }
  }

  const totalValue =
    state.programList.length > 0
      ? Math.round(
        state.programList.reduce((sum, p) => sum + (p?.value || 0), 0) / state.programList.length
      )
      : 0

  const {
    surveyList,
    state: {resultList},
    getResults
  } = useSurvey()

  useEffect(() => {
    if (isNext)
      goToNext()
  }, [isNext])

  useEffect(() => {
    console.time('loading')

    if (uid) { // accent test now
      startInterval()
      setStep(step, toAdd)
      identify(uid, searchParams.get('email'), {lang: i18n.resolvedLanguage})
      return
    }

    if (resultList.length < surveyList.length) {
      navigate(getUrl('/'), {replace: true})
      return
    }

    try {
      console.log('try fetch summarize...')
      console.time('fetch')

      let version = 2

      if (window.landing === LandingEnum.charisma)
        version = 6

      fetch(`${process.env.REACT_APP_API_URI}web-sessions/summarize/?version=${version}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          lang: i18n.resolvedLanguage,
          version: process.env.REACT_APP_VERSION,
          session_uid: (window.session_uid || window.sessionStorage.getItem('session_uid')),
          age: window.localStorage.getItem('age'),
          data: getResults(),
        })
      })
        .then(response => {
          console.timeEnd('fetch')
          console.log(response)

          return response.json()
        })
        .then(({messages, ai_coach_result}) => {
          console.log('messages', ai_coach_result)

          if (messages || ai_coach_result) {
            console.warn('valid')
            // window.summarize = messages

            window.sessionStorage.setItem(
              'summarize',
              JSON.stringify(messages || ai_coach_result)
            )
          } else
            console.warn('not valid')
        })
    } catch (err) {
      console.error(err)
    }

    startInterval()
    setStep(step, toAdd)
    setTrack('loader')

    return () => clearInterval(state.timer)
  }, [])


  const startInterval = () => {
    if (state.timer || !state.intervals.length)
      clearInterval(state.timer)

    const ind = Math.floor(Math.random() * state.intervals.length)
    state.timeout = state.intervals[ind]
    state.interval = Math.round(state.timeout / 100)
    state.time = state.interval
    state.pauses = Math.floor(Math.random() * 3)
    delete state.pause
    // console.log('pauses', state.pauses)

    state.intervals.splice(ind, 1)
    startTimer()
  }

  const startTimer = () => {
    // clearInterval(state.timer);

    state.timer = setInterval(() => {
      let isNext = true, isEnd = false

      for (const item of state.programList) {
        if (item.value < 100) {
          item.value++
          isEnd = item.value === 100

          if (item.value !== pause || !item.title)
            isNext = false

          if (
            // [50, 100].includes(item.value)
            item.value === 100 ||
            item.value === 50
          ) {
            if (!i18n.exists('loading.name')) {
              headerRef.current?.classList.add('fade-in')
              setTimeout(() => {
                headerRef.current?.classList.remove('fade-in')
              }, 1000)
            }
          } else {
            if (!state.pause && state.pauses > 0) {
              state.pause = item.value + Math.floor(Math.random() * (99 - item.value))
              // console.log('pause', state.pause)
              state.pauses--
            }

            if (!isNext && state.pause && item.value >= state.pause) {
              // console.log('paused')
              clearInterval(state.timer)
              delete state.pause
              state.time = state.interval * (Math.floor(Math.random() * 2) ? 0.5 : 2)
              setTimeout(startTimer, 250 + Math.floor(Math.random() * 750))
            }
          }

          break
        }
      }

      if (isNext)
        clearInterval(state.timer)
      else if (isEnd)
        startInterval()

      setState({...state})
    }, state.time)
  }

  function handleChange(index, checkedList) {
    // console.log('handleChange', index, checkedList)

    state.resultList[index] = checkedList
    // setState({...state})

    window.localStorage.setItem(
      'program_results',
      JSON.stringify(state.resultList)
    )

    upTimer(() => {
      // if (A73.value === 'B')
      //   setIsContinue(isContinue + 1)
      // else
        startTimer()
    })
  }

  const handleFillResults = () => {
    for (const [i, item] of programList.entries()) {
      if (!state.resultList[i])
        state.resultList[i] = item.title ? [0] : null
    }

    window.localStorage.setItem(
      'program_results',
      JSON.stringify(state.resultList)
    )

    goToNext()
  }

  const goToNext = () => {
    console.timeEnd('loading')
    navigate(nextUrl)
  }

  let lastTitle, lastIndex

  return (
    <div className={'wrap fixed'}>
      <Top style={{position: 'relative'}}>
        {
          process.env.REACT_APP_DEBUG &&
          <Button variant={'gold'} size={'sm'} onClick={handleFillResults} style={{position: 'fixed', top: 5, right: 5, width: 'auto'}}>fill</Button>
        }
        <Logo/>

        <CircularProgress value={totalValue} size={96} strokeWidth={2} animate={true}>
          <img src={'/charisma/static/img/avatar.png'} alt={'ava'} width={80} height={80}/>
        </CircularProgress>

        <div>
          <h1 ref={headerRef} className={'pre-line'} style={{display: 'inline'}}>
            {header}
            {
              // isNext
              //   ? <>Communicate better<br/><em>with Vocal Image</em></>
              //   : header
            }
          </h1>
          {
            !isNext &&
            <span className="dots h1"><span>.</span><span>.</span><span>.</span></span>
          }
        </div>

        {
          state.programList.map(({name, value, title}, index) => {
            if (!value)
              return false

            if (value === pause && title) {
              lastTitle = title
              lastIndex = index
            }

            return (
              <div key={index} className={'progress-wrap' + (!value ? ' disabled' : '')}>
                <div className={'gap-2'}>
                  <label className={'text-start pre-line'}>
                    {name}
                    {
                    value > 0 && value < 100 &&
                      <span className="dots"><span>.</span><span>.</span><span>.</span></span>
                    }
                  </label>
                  {
                    // value > 0 && value < 100 &&
                    // <em>{value}%</em>
                  }
                  {
                    value >= 100 &&
                    <Checkbox checked={true} disabled={true} className={'success'}/>
                  }
                </div>
                <div className={'progress common animate'}><div style={{width: value + '%', backgroundColor: '#333A49'}}></div></div>
                {
                  lastTitle &&
                  <>
                    <div className={'line'}/>
                    <div className={'block'} style={{position: 'relative', zIndex: 100}}>
                      <div className={'items'}>
                        <div style={{flexDirection: 'column', gap: '0.25rem'}}>
                          <em>{t('popNote')}</em>
                          <h3>{title}</h3>
                        </div>
                        <ChoiceList
                          survey={{type: SurveyEnum.boolean, list: [{title: t0('no')}, {title: t0('yes')}]}}
                          onChange={handleChange.bind(this, lastIndex)}/>
                      </div>
                    </div>
                  </>
                }
              </div>
            )
          })
        }
      </Top>

      <Bottom footer={false} preload={preload}/>
    </div>
  )
}